import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, of, throwError, take, catchError } from 'rxjs';
import { StorageService } from '../base/storage.service';
import { LoginRequest, LoginResponse, RefreshTokenRequest, RefreshTokenResponse } from '../../models/auth/auth.model';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly http = inject(HttpClient);
  private readonly storage = inject(StorageService);
  private readonly router = inject(Router);
  public URL_API = environment.apiUrl;

  login(username: string, password: string): Observable<LoginResponse> {
    const request: LoginRequest = { u: username, p: password, v: environment.loginVersion };
    return this.http.post<LoginResponse>(`${this.URL_API}/api/Account/Login`, request).pipe(
      take(1),
      catchError(error => throwError(() => error)),
    );
  }

  logout(): void {
    this.storage.clearCredentials();
    window.dispatchEvent(new CustomEvent('user-logout'));
    this.router.navigate(['/login']);
  }

   // ToDoLa api no esta lista para el refresh
  refreshToken(body: RefreshTokenRequest): Observable<RefreshTokenResponse | null> {
    return of(null);
    // return this.http.post<RefreshTokenResponse>(`${this.URL_API}/api/Account/Refresh`, body).pipe(
    //   take(1),
    //   catchError(() => of(null))
    // );
  }
}
